import type { FC } from 'react';

import { categoryCss } from './styles';

export const Category: FC<{ title: string }> = ({ title }) => (
  <span className={categoryCss}>{title}</span>
);
